import { render, staticRenderFns } from "./ChangeDoReference.vue?vue&type=template&id=7aae993c&"
import script from "./ChangeDoReference.vue?vue&type=script&lang=js&"
export * from "./ChangeDoReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports